import { render, staticRenderFns } from "./LicenseSelectorContainer.vue?vue&type=template&id=ab98f316"
import script from "./LicenseSelectorContainer.vue?vue&type=script&lang=js"
export * from "./LicenseSelectorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports